import styled from "styled-components";

const Row = styled.div``;
export default Row;
